import { render, staticRenderFns } from "./ShipmentTypeCreateDialog.vue?vue&type=template&id=672567f1&scoped=true"
import script from "./ShipmentTypeCreateDialog.vue?vue&type=script&lang=ts"
export * from "./ShipmentTypeCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672567f1",
  null
  
)

export default component.exports